import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { IUser } from '../../../../../app/resource/user/user.types';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { useApiRequestState } from '../../../../../utils/api.utils';
import Loader from 'react-loader-spinner';
import { ISettingsNotificationFormDatao } from '../types';
import { updateUserProfile } from '../../../../../app/page/page-storage/users/users.actions';
import { settingsSelectors } from '../../../../../app/resource/settings/settings.selectors';

export const Notifications = () => {
  const dispatch = useDispatch();
  const formProps = useForm();
  const loggedUserId = useSelect(authSelectors.selectLoggedUser) as IUser['id'];
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId) as IUser;
  const [showLoader] = useApiRequestState('updateUser');

  const settings = useSelectWithParams(
    settingsSelectors.selectResourceById,
    loggedUser?.tenantId ? loggedUser.tenantId : '',
  );

  const onSubmit = (formData: ISettingsNotificationFormDatao) => {
    dispatch(updateUserProfile(formData));
  };

  return (
    <div className="col px-0">
      <div className="field-container px-2 mb-5">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic mb-3">
          <h2 className="f-14 white">NOTIFICATIONS</h2>
        </div>
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="" className="f-14">
                How you get notified
              </label>
              <p className="f-1 mb-1 blueGray">
                Please note: You can’t unsubscribe from important emails about your account, like status and billing
                updates.
              </p>
            </div>
          </div>
        </div>
        <FormProvider {...formProps}>
          <form
            className="topic-form"
            id="notification-form"
            onSubmit={formProps.handleSubmit((formData: ISettingsNotificationFormDatao) => onSubmit(formData))}
            method="post"
          >
            <div className="row mb-1">
              <div className="col-12 pr-1">
                <div className="field-container flex aic mb-1">
                  <label className="switch big-switch mr-1 mb-0" htmlFor="enableEmailNotification">
                    <input
                      type="checkbox"
                      className="switch-input change-theme"
                      id="enableEmailNotification"
                      name="enableEmailNotification"
                      defaultChecked={loggedUser.enableEmailNotification}
                      ref={formProps.register}
                    />
                    <span className="switch-label"></span>
                    <span className="switch-handle"></span>
                  </label>
                  <span className="switch-inline-text">Email (Auto Sets All On for Email)</span>
                </div>
              </div>
            </div>
            {settings?.slackWorkspaceName && (
              <div className="row mb-1">
                <div className="col-12 pr-1">
                  <div className="field-container flex aic mb-1">
                    <label className="switch big-switch mr-1 mb-0" htmlFor="enableSlackNotification">
                      <input
                        type="checkbox"
                        className="switch-input change-theme"
                        id="enableSlackNotification"
                        name="enableSlackNotification"
                        defaultChecked={loggedUser.enableSlackNotification}
                        ref={formProps.register}
                      />
                      <span className="switch-label"></span>
                      <span className="switch-handle"></span>
                    </label>
                    <span className="switch-inline-text">Slack (Auto Sets All On for Slack)</span>
                  </div>
                </div>
              </div>
            )}
            {/*             <div className="row">
              <div className="col-12 pr-1">
                <div className="field-container flex aic mb-1">
                  <label className="switch big-switch mr-1 mb-0" htmlFor="enableWebNotificationCheck">
                    <input
                      type="checkbox"
                      className="switch-input change-theme"
                      id="enableWebNotificationCheck"
                      name="enableWebNotification"
                      defaultChecked={user.enableWebNotification === '1'}
                      ref={formProps.register}
                    />
                    <span className="switch-label"></span>
                    <span className="switch-handle"></span>
                  </label>
                  <span className="switch-inline-text">Desktop (Notification Center)</span>
                </div>
              </div>
            </div> */}
            {/*             <div className="row">
              <div className="col-12 pr-1">
                <div className="field-container flex aic mb-1">
                  <label className="switch big-switch mr-1 mb-0" htmlFor="textCheck">
                    <input
                      type="checkbox"
                      className="switch-input change-theme"
                      id="textCheck"
                      name="textOption"
                      ref={formProps.register}
                    />
                    <span className="switch-label"></span>
                    <span className="switch-handle"></span>
                  </label>
                  <span className="switch-inline-text">Text Option (Premium)</span>
                </div>
              </div>
            </div> */}

            <div className="row">
              <div className="col-12 flex">
                <button type="submit" className="btn m-0" title="Save">
                  {showLoader ? (
                    <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />
                  ) : (
                    'Save'
                  )}
                </button>
              </div>
            </div>
            {/*         <hr />
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="GDPR" className="f-14">
                2 Factor Authentication Login
              </label>
              <p className="f-1 mb-1 blueGray">
                Choose what notifications matter to you and how you get notified about them.
              </p>
            </div>
            <div className="icon-grid-header">
              <span className="small-icon">
                <img src="images/email-blueGray.svg" alt="" className="img-fluid" />
              </span>
              <span className="small-icon">
                <i className="icon-bell blueGray"></i>
              </span>
              <span className="small-icon">
                <img src="images/mobile-phone.svg" alt="" className="img-fluid" />
              </span>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="two-factor-email" />
                    <label htmlFor="two-factor-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="two-factor-phone" />
                    <label htmlFor="two-factor-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">2 Factor Code Delivery Notification</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="GDPR" className="f-14">
                Company Account (Account Holder Only)
              </label>
              <p className="f-1 mb-1 blueGray">
                Choose what notifications matter to you and how you get notified about them.
              </p>
            </div>
            <div className="icon-grid-header">
              <span className="small-icon">
                <img src="images/email-blueGray.svg" alt="" className="img-fluid" />
              </span>
              <span className="small-icon">
                <i className="icon-bell blueGray"></i>
              </span>
              <span className="small-icon">
                <img src="images/mobile-phone.svg" alt="" className="img-fluid" />
              </span>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="payment-reminder-email" />
                    <label htmlFor="payment-reminder-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="payment-reminder-notif" />
                    <label htmlFor="payment-reminder-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="payment-reminder-phone" />
                    <label htmlFor="payment-reminder-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Payment Reminder</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="payment-complete-email" />
                    <label htmlFor="payment-complete-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="payment-complete-notif" />
                    <label htmlFor="payment-complete-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="payment-complete-phone" />
                    <label htmlFor="payment-complete-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Payment Complete</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="default-payment-change-email" />
                    <label htmlFor="default-payment-change-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="default-payment-change-notif" />
                    <label htmlFor="default-payment-change-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">Default Payment Method Change</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="GDPR" className="f-14">
                Reminders
              </label>
              <p className="f-1 mb-1 blueGray">
                Choose what notifications matter to you and how you get notified about them.
              </p>
            </div>
            <div className="icon-grid-header">
              <span className="small-icon">
                <img src="images/email-blueGray.svg" alt="" className="img-fluid" />
              </span>
              <span className="small-icon">
                <i className="icon-bell blueGray"></i>
              </span>
              <span className="small-icon">
                <img src="images/mobile-phone.svg" alt="" className="img-fluid" />
              </span>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="todo-1day-email" />
                    <label htmlFor="todo-1day-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-1day-notif" />
                    <label htmlFor="todo-1day-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-1day-phone" />
                    <label htmlFor="todo-1day-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a to do assigned to you is due in 1 day</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="todo-same-day-email" />
                    <label htmlFor="todo-same-day-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-same-day-notif" />
                    <label htmlFor="todo-same-day-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-same-day-phone" />
                    <label htmlFor="todo-same-day-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a to do assigned to you is due (same day).</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="todo-daily-email" />
                    <label htmlFor="todo-daily-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-daily-notif" />
                    <label htmlFor="todo-daily-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-daily-phone" />
                    <label htmlFor="todo-daily-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a to do assigned to you is overdue (daily reminder).</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="quarterly-due-email" />
                    <label htmlFor="quarterly-due-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-due-notif" />
                    <label htmlFor="quarterly-due-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-due-phone" />
                    <label htmlFor="quarterly-due-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Quarterly Initiative is due.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="quarterly-off-email" />
                    <label htmlFor="quarterly-off-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-off-notif" />
                    <label htmlFor="quarterly-off-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-off-phone" />
                    <label htmlFor="quarterly-off-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Quarterly Initiative is off track (weekly reminder).</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="daily-calendar-recap-email" />
                    <label htmlFor="daily-calendar-recap-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="daily-calendar-recap-notif" />
                    <label htmlFor="daily-calendar-recap-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="daily-calendar-recap-phone" />
                    <label htmlFor="daily-calendar-recap-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Daily Calendar Recap</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="GDPR" className="f-14">
                Team Settings
              </label>
              <p className="f-1 mb-1 blueGray">
                Choose what notifications matter to you and how you get notified about them.
              </p>
            </div>
            <div className="icon-grid-header">
              <span className="small-icon">
                <img src="images/email-blueGray.svg" alt="" className="img-fluid" />
              </span>
              <span className="small-icon">
                <i className="icon-bell blueGray"></i>
              </span>
              <span className="small-icon">
                <img src="images/mobile-phone.svg" alt="" className="img-fluid" />
              </span>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="team-assign-email" />
                    <label htmlFor="team-assign-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="team-assign-notif" />
                    <label htmlFor="team-assign-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">You are assigned to a team.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="team-settings-change-email" />
                    <label htmlFor="team-settings-change-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="team-settings-change-notif" />
                    <label htmlFor="team-settings-change-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">Team settings have been changed on one of your teams.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="team-removed-email" />
                    <label htmlFor="team-removed-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="team-removed-notif" />
                    <label htmlFor="team-removed-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">When you have been removed from a team.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="todo-assigned-email" />
                    <label htmlFor="todo-assigned-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-assigned-notif" />
                    <label htmlFor="todo-assigned-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="todo-assigned-phone" />
                    <label htmlFor="todo-assigned-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When an action item is assigned to you.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="quarterly-assigned-email" />
                    <label htmlFor="quarterly-assigned-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-assigned-notif" />
                    <label htmlFor="quarterly-assigned-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-assigned-phone" />
                    <label htmlFor="quarterly-assigned-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Quarterly Initiative assigned to you</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="team-settings-change-email" />
                    <label htmlFor="team-settings-change-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="team-settings-change-notif" />
                    <label htmlFor="team-settings-change-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">When team settings change. </p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="trello-added-email" />
                    <label htmlFor="trello-added-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-added-notif" />
                    <label htmlFor="trello-added-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">When a Trello board is added.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="trello-item-status-email" />
                    <label htmlFor="trello-item-status-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-item-status-notif" />
                    <label htmlFor="trello-item-status-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-item-status-phone" />
                    <label htmlFor="trello-item-status-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Trello board item’s status updates.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="meeting-reminder-email" />
                    <label htmlFor="meeting-reminder-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-notif" />
                    <label htmlFor="meeting-reminder-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-phone" />
                    <label htmlFor="meeting-reminder-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Upcoming Meeting Reminder (Day before)</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="meeting-reminder-morning-email" />
                    <label htmlFor="meeting-reminder-morning-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-notif" />
                    <label htmlFor="meeting-reminder-morning-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-phone" />
                    <label htmlFor="meeting-reminder-morning-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Upcoming Meeting Reminder (Morning Of)</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="GDPR" className="f-14">
                Account Settings
              </label>
              <p className="f-1 mb-1 blueGray">
                Choose what notifications matter to you and how you get notified about them.
              </p>
            </div>
            <div className="icon-grid-header">
              <span className="small-icon">
                <img src="images/email-blueGray.svg" alt="" className="img-fluid" />
              </span>
              <span className="small-icon">
                <i className="icon-bell blueGray"></i>
              </span>
              <span className="small-icon">
                <img src="images/mobile-phone.svg" alt="" className="img-fluid" />
              </span>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="you-assigned-team-email" />
                    <label htmlFor="you-assigned-team" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="you-assigned-team-notif" />
                    <label htmlFor="you-assigned-team-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="you-assigned-team-phone" />
                    <label htmlFor="you-assigned-team-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">You are assigned to an account.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="account-settings-change-email" />
                    <label htmlFor="account-settings-change-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="account-settings-change-notif" />
                    <label htmlFor="account-settings-change-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">Account settings have been changed.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="you-account-removed-email" />
                    <label htmlFor="you-account-removed-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="you-account-removed-notif" />
                    <label htmlFor="you-account-removed-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">When you have been removed from an account. </p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="acc-todo-assigned-email" />
                    <label htmlFor="acc-todo-assigned-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="acc-todo-assigned-notif" />
                    <label htmlFor="acc-todo-assigned-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="acc-todo-assigned-phone" />
                    <label htmlFor="acc-todo-assigned-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When an action item is assigned to you.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="quarterly-assigned-email" />
                    <label htmlFor="quarterly-assigned-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-assigned-notif" />
                    <label htmlFor="quarterly-assigned-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="quarterly-assigned-phone" />
                    <label htmlFor="quarterly-assigned-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Quarterly Initiative assigned to you</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="trello-added-email" />
                    <label htmlFor="trello-added-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-added-notif" />
                    <label htmlFor="trello-added-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-added-phone" />
                    <label htmlFor="trello-added-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Trello board is added.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="trello-item-status-email" />
                    <label htmlFor="trello-item-status-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-item-status-notif" />
                    <label htmlFor="trello-item-status-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="trello-item-status-phone" />
                    <label htmlFor="trello-item-status-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a Trello board item’s status updates.</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="meeting-reminder-morning-email" />
                    <label htmlFor="meeting-reminder-morning-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-notif" />
                    <label htmlFor="meeting-reminder-morning-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-phone" />
                    <label htmlFor="meeting-reminder-morning-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">When a client completes an action item. </p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="meeting-reminder-morning-email" />
                    <label htmlFor="meeting-reminder-morning-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-notif" />
                    <label htmlFor="meeting-reminder-morning-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-phone" />
                    <label htmlFor="meeting-reminder-morning-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Upcoming Meeting Reminder (Day before)</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="meeting-reminder-morning-email" />
                    <label htmlFor="meeting-reminder-morning-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-notif" />
                    <label htmlFor="meeting-reminder-morning-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="meeting-reminder-morning-phone" />
                    <label htmlFor="meeting-reminder-morning-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">Upcoming Meeting Reminder (Morning Of)</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container">
              <label htmlFor="GDPR" className="f-14">
                User Settings
              </label>
              <p className="f-1 mb-1 blueGray">
                When your role has been changed on any level (System Admin, Team Role, Account Role.)
              </p>
            </div>
            <div className="icon-grid-header">
              <span className="small-icon">
                <img src="images/email-blueGray.svg" alt="" className="img-fluid" />
              </span>
              <span className="small-icon">
                <i className="icon-bell blueGray"></i>
              </span>
              <span className="small-icon">
                <img src="images/mobile-phone.svg" alt="" className="img-fluid" />
              </span>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="you-assigned-team-email" />
                    <label htmlFor="you-assigned-team" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="you-assigned-team-notif" />
                    <label htmlFor="you-assigned-team-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="you-assigned-team-phone" />
                    <label htmlFor="you-assigned-team-phone" className="pl-2"></label>
                  </div>
                </span>
              </div>
              <p className="f-1">TBD</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="account-settings-change-email" />
                    <label htmlFor="account-settings-change-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="account-settings-change-notif" />
                    <label htmlFor="account-settings-change-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">TBD</p>
            </div>
            <div className="icon-grid">
              <div className="grid-checkboxes">
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" checked id="you-account-removed-email" />
                    <label htmlFor="you-account-removed-email" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <div className="remember-checkbox flex aic jcl m-0">
                    <input type="checkbox" name="" id="you-account-removed-notif" />
                    <label htmlFor="you-account-removed-notif" className="pl-2"></label>
                  </div>
                </span>
                <span className="small-icon">
                  <span className="checkbox-unavailable">NA</span>
                </span>
              </div>
              <p className="f-1">TBD</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 flex">
            <a href="/" className="btn m-0" title="Save">
              Save
            </a>
          </div>
        </div> */}
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
